export const notification = {
    seeAll: true,
    show: true,
    enable: true,
    overridePathActionOnNewAssignation: '/followed/tab/groupsdetail',
};